import Vue from 'vue';
var drag = Vue.directive('drag', {
  bind: function bind(el, binding) {
    el.ontouchstart = function (e) {
      // let disX = e.touches[0].pageX - el.offsetLeft;
      var disY = e.touches[0].pageY - el.offsetTop;
      var startX = e.changedTouches[0].pageX;
      var startY = e.changedTouches[0].pageY;

      document.ontouchmove = function (e) {
        var moveEndX = e.changedTouches[0].pageX,
            moveEndY = e.changedTouches[0].pageY,
            X = moveEndX - startX,
            Y = moveEndY - startY;

        if (Math.abs(X) > Math.abs(Y) && X > 0) {
          return false;
        } else if (Math.abs(X) > Math.abs(Y) && X < 0) {
          return false;
        }

        var top = parseInt(e.touches[0].pageY) - parseInt(disY);

        if (top < 100) {
          return false;
        }

        if (top < 0) {
          //左右边界限制
          top = 0;
        } else if (top > document.documentElement.offsetHeight - el.offsetHeight) {
          top = document.documentElement.offsetHeight - el.offsetHeight;
        }

        el.style.top = top + 'px';
      };

      document.ontouchend = function () {
        document.ontouchmove = document.ontouchend = null;
      };
    };
  }
});
export default drag;